import React from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

const CelluarInput = ({ onChange, value, defaultValue, disabled, placeholder }) => {
  const countries = [
    'ZA',
    'AO',
    'BW',
    'GB',
    'KM',
    'CD',
    'LS',
    'MG',
    'MW',
    'MU',
    'MZ',
    'NA',
    'SC',
    'SD',
    'SZ',
    'TZ',
    'ZM',
    'ZW',
  ];

  return (
    <PhoneInput
      international
      placeholder={placeholder ? placeholder : 'Enter phone number'}
      onChange={onChange}
      flags={flags}
      defaultCountry="ZA"
      countryCallingCodeEditable={false}
      countries={countries}
      smartCaret={false}
      value={value || defaultValue || undefined}
      disabled={disabled}
    />
  );
};

export default CelluarInput;
